import React, { Component, Fragment } from "react";
import { Doughnut } from 'react-chartjs-2';
import getDashboardStats from "../../services/dashboardStatsService";

class DashboardStats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statsData: null,
            period: null
        };
    }

    componentDidMount() {
        this.fetchStats();
    }

    componentDidUpdate(prevProps) {
        if (parseInt(prevProps.filterOnUserId) != parseInt(this.props.filterOnUserId)) {
            this.fetchStats();
        }
    }

    fetchStats = async () => {
        let statsData;
        try {
            const response = await getDashboardStats(this.props.filterOnUserId);
            statsData = response.data[0];
        } catch (e) { }

        this.setState({
            statsData
        });
    };

    render() {
        const { statsData } = this.state;
        const chartOptions = { maintainAspectRatio: false, cutoutPercentage: 75 };

        if (!statsData) return null;

        const tenderData = {
            datasets: [{
                borderColor: ['#28a745', '#0a1f2d'],
                data: [statsData.tenderValue, statsData.tenderTotalValue - statsData.tenderValue],
                backgroundColor: ['#28a745', '#0a1f2d'],
            }]
        };

        const orderData = {
            datasets: [{
                borderColor: ['#28a745', '#0a1f2d'],
                data: [statsData.orderValue, statsData.orderTotalValue - statsData.orderValue],
                backgroundColor: ['#28a745', '#0a1f2d'],
            }]
        };

        const marginData = {
            datasets: [{
                borderColor: ['#28a745', '#dc3545'],
                data: [statsData.marginPercent, 100 - statsData.marginPercent],
                backgroundColor: ['#28a745', '#dc3545'],
            }]
        };

        const deliveryData = {
            datasets: [{
                borderColor: ['#28a745', '#0a1f2d'],
                data: [statsData.deliveryValue, statsData.deliveryTotalValue - statsData.deliveryValue],
                backgroundColor: ['#28a745', '#0a1f2d'],
            }]
        };

        return (
            <Fragment>
                <div className="dashboard-stats col-blue2-bg">
                    <div className="row">
                        <div className="col-8 mt-2">
                            <span>Fem dagar</span>
                        </div>
                        <div className="col-4 mt-2">
                            <span>Månad</span>
                        </div>
                    </div>
                    <div className="placeholder">
                        <div className="row pb-2">
                            <div className="col-4 js-tendersChart">
                                <Doughnut data={tenderData} options={chartOptions} />
                            </div>
                            <div className="col-4 js-ordersChart">
                                <Doughnut data={orderData} options={chartOptions} />
                            </div>
                            <div className="col-4 js-deliveryChart">
                                <Doughnut data={deliveryData} options={chartOptions} />
                            </div>
                        </div>
                        <div className="row row-overlay">
                            <div className="col-4 text-center align-self-center">
                                <strong>Offerter</strong><br />
                                {statsData.tenderCount} ({statsData.tenderTotalCount}) st<br />
                                {statsData.tenderValue} ({statsData.tenderTotalValue}) tkr
                        </div>
                            <div className="col-4 text-center align-self-center">
                                <strong>Ordrar</strong><br />
                                {statsData.orderCount} ({statsData.orderTotalCount}) st<br />
                                {statsData.orderValue} ({statsData.orderTotalValue}) tkr
                        </div>
                            <div className="col-4 text-center align-self-center">
                                <strong>Leverans</strong><br />
                                {statsData.deliveryCount} ({statsData.deliveryTotalCount}) st<br />
                                {statsData.deliveryValue} ({statsData.deliveryTotalValue}) tkr
                        </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default DashboardStats;
